import { EnvironmentPermissionsEnum } from 'api';

export const currentUserHasPermission = (
  permissions: EnvironmentPermissionsEnum[],
  permission: EnvironmentPermissionsEnum,
) => !!permissions.find((perm) => perm === permission);

export const currentUserHasCreateIssuerPermission = (permissions: EnvironmentPermissionsEnum[]) =>
  currentUserHasPermission(permissions, EnvironmentPermissionsEnum.CREATE_ISSUER);

export const currentUserHasEditIssuanceDocumentPermission = (permissions: EnvironmentPermissionsEnum[]) =>
  currentUserHasPermission(permissions, EnvironmentPermissionsEnum.MANAGE_ISSUANCE_DOCUMENTS);

export const currentUserHasValidateCryptoSecuritiesPermission = (permissions: EnvironmentPermissionsEnum[]) =>
  currentUserHasPermission(
    permissions,
    EnvironmentPermissionsEnum.MANAGE_FLAG_FOR_CRYPTO_SECURITY_CREATION_AND_VALIDATE_CRYPTO_SECURITIES,
  );

export const currentUserHasManageOrganizationsPermission = (permissions: EnvironmentPermissionsEnum[]) =>
  currentUserHasPermission(permissions, EnvironmentPermissionsEnum.MANAGE_ORGANIZATIONS);

export const currentUserHasManageEnvironmentPermission = (permissions: EnvironmentPermissionsEnum[]) =>
  currentUserHasPermission(permissions, EnvironmentPermissionsEnum.MANAGE_ENVIRONMENT_PERMISSIONS);

export const currentUserHasManageUsersAndGroupsPermission = (permissions: EnvironmentPermissionsEnum[]) =>
  currentUserHasPermission(permissions, EnvironmentPermissionsEnum.MANAGE_ENVIRONMENT_USERS_AND_GROUPS);
